import React from 'react';
import PropTypes from 'prop-types';
import { LEGAL_TABLE_COLUMNS_NAMES } from '../../constants';
import { LegalForm } from '../legal-form';
import { LegalInfoTable } from '../legal-info-table';

export const LegalModalContent = ({ legalInfo, isLegalFormOpen, isLegalInfoLoading }) => {
	return isLegalFormOpen ? (
		<LegalForm />
	) : (
		<LegalInfoTable rows={legalInfo} isTableDataLoading={isLegalInfoLoading} columns={LEGAL_TABLE_COLUMNS_NAMES} />
	);
};

LegalModalContent.propTypes = {
	legalInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					name: PropTypes.string,
					role: PropTypes.string,
				}),
			]).isRequired,
		}),
	),
	isLegalFormOpen: PropTypes.bool.isRequired,
	isLegalInfoLoading: PropTypes.bool.isRequired,
};
